import sponsor0 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/00. Pos Bloc New.png"
import sponsor1 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/01. Sponsor/01. SMM.png"
import sponsor2 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/01. Sponsor/02. Sekolah.mu.png"
import sponsor3 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/01. Sponsor/03. Keluarga Kita.png"
import sponsor4 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/01. Sponsor/04. Grafie.png"
import sponsor5 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/01. Sponsor/05._Count_Three.PNG"
import sponsor6 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/01. Sponsor/06._Hello_Panda_New_2019-01.png"
import sponsor7 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/01. Sponsor/FIX NEW LOGO MEIJI WELLNESS.png"

import komunitas1 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/ABC Reading Club.jpeg"
import komunitas2 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/AYODI.png"
import komunitas3 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Birth and Bloom.png"
import komunitas4 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Bookhive.PNG"
import komunitas5 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Dig and Beyond.png"
import komunitas6 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Flores_Writers_Festival.png"
import komunitas7 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Humi.jpg"
import komunitas8 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Indonesia Book Party - Green Transparent.png"
import komunitas9 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Jakarta Good Guide.png"
import komunitas10 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Karyaraya 2024.png"
import komunitas11 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Kitabisa_Blue_Square.png"
import komunitas12 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Klub Buku Nyala Matahari (logo).png"
import komunitas13 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/LOGO LITTLE QUOKKA.png"
import komunitas14 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/LOGO RDP TRANSPARANT (1) (1).png"
import komunitas15 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo BBB Book Club.jpeg"
import komunitas16 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo Bukuku.Club-1 (1).png"
import komunitas17 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo Detectives ID.png"
import komunitas18 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo Green Meadow.png"
import komunitas19 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo Konekin.png"
import komunitas20 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo Kurcaci Dongeng.png"
import komunitas21 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo Lingkar Baca (Circle).png"
import komunitas22 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo Narabahasa.png"
import komunitas23 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo NgoJak (1).png"
import komunitas24 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Logo Pesta Literasi Indonesia.png"
import komunitas25 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/MILI KECIL FONT.png"
import komunitas26 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Mata Cinta.jpeg"
import komunitas27 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Ngramu Jamoe.jpeg"
import komunitas28 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Paman Gery 2.jpeg"
import komunitas29 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Papermoon Puppet Theatre.jpg"
import komunitas30 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Provisi Mandiri Pratama Logo (1).png"
import komunitas31 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/RSJ BLACK.png"
import komunitas32 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Rembuku.PNG"
import komunitas33 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/SEKAT Studio.png"
import komunitas34 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/SRWF 2023.PNG"
import komunitas35 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/TaCita.png"
import komunitas36 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Ulang Alik (Blue).png"
import komunitas37 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/WISATA KREATIF JAKARTA.png"
import komunitas38 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Wahana Kreator.png"
import komunitas39 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/Waktunya Main.PNG"
import komunitas40 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/cilikba bulat.png"
import komunitas41 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/dari halte ke halte.png"
import komunitas42 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/logo KawanPuan.png"

import komunitas43 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/addition/Gulali.JPEG"
import komunitas44 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/addition/Kamar Kata-Kata.png"
import komunitas45 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/addition/Mai (1).png"
// import komunitas46 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/addition/Miles New Logo White.png"
import komunitas47 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/addition/PS2_Miles 01.png"
import komunitas48 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/addition/Save lagu anak.jpeg"
import komunitas49 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/addition/Sekolah kambang.PNG"
import komunitas50 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/02. komunitas/addition/visinema group_black.png"


import media1 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Bahana FM.png"
import media2 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Broadwayworld Indonesia logo-1.png"
import media3 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/LOGO AUTOMOTO.png"
import media4 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/LOGO NEVERLAND (HORISONTAL)-03.png"
import media5 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Logo FAMZ Guide - Color.png"
import media6 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Logo Jayakarta.news.png"
import media7 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Logo-05-05.png"
import media8 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Logo-FTNews2.png"
import media9 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Mommies Daily.PNG"
import media10 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Omong-omong.PNG"
import media11 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/TVRI World.png"
import media12 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/03. media partner/Travelmaker Indonesia.png"


import penerbit1 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/-Utama- Logo GagasMedia - Versi Hitam.png"
import penerbit2 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/20210801_AKHIRPEKAN_LOGOMARK 1.png"
import penerbit3 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/20210801_AKHIRPEKAN_WORDMARK 1.png"
import penerbit4 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Bookabook_logo_2.png"
import penerbit5 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Bukune.png"
import penerbit6 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/D9D29AB0-617E-4CA5-BA6D-868D172D23C2.png"
import penerbit7 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Harulogo2.png"
import penerbit8 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Hires-logo-tomo.png"
import penerbit9 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Indonesia Tera.png"
import penerbit10 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Kawan Pustaka.jpg"
import penerbit11 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Kayabaca Logo Full - Green_Vector (1).png"
import penerbit12 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Logo G Gradien.png"
import penerbit13 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Logo Penerbit Infermia.png"
import penerbit14 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Logo Shira Media.png"
import penerbit15 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Logo Teroka Hitam (3).png"
import penerbit16 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Logo blackswan  (1).png"
import penerbit17 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Logo lingkar antarnusa.png"
import penerbit18 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/NARATAMA LOGO FIX1.png"
import penerbit19 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Pibo Logo.png"
import penerbit20 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/Rakata_Normal.png"
import penerbit21 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/gpu.png"
import penerbit22 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/logo akad berwarna.png"
import penerbit23 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/logo kobam full.png"
import penerbit24 from "../../src/asset/2024/patjarkeciljuni/kawanpatjar/04. penerbit/penerbit-baca-logo.png"


export const KawanPatjar = [
  sponsor0,
  sponsor1,
  sponsor2,
  sponsor3,
  sponsor4,
  sponsor5,
  sponsor6,
  sponsor7,
]

export const komunitas = [
  komunitas1,
  komunitas2,
  komunitas3,
  komunitas4,
  komunitas5,
  komunitas6,
  komunitas7,
  komunitas8,
  komunitas9,
  komunitas10,
  komunitas11,
  komunitas12,
  komunitas13,
  komunitas14,
  komunitas15,
  komunitas16,
  komunitas17,
  komunitas18,
  komunitas19,
  komunitas20,
  komunitas21,
  komunitas22,
  komunitas23,
  komunitas24,
  komunitas25,
  komunitas26,
  komunitas27,
  komunitas28,
  komunitas29,
  komunitas30,
  komunitas31,
  komunitas32,
  komunitas33,
  komunitas34,
  komunitas35,
  komunitas36,
  komunitas37,
  komunitas38,
  komunitas39,
  komunitas40,
  komunitas41,
  komunitas42,
  komunitas43,
  komunitas44,
  komunitas45,
  // komunitas46,
  komunitas47,
  komunitas48,
  komunitas49,
  komunitas50,
]

export const penerbit = [
  penerbit1,
  penerbit2,
  penerbit3,
  penerbit4,
  penerbit5,
  penerbit6,
  penerbit7,
  penerbit8,
  penerbit9,
  penerbit10,
  penerbit11,
  penerbit12,
  penerbit13,
  penerbit14,
  penerbit15,
  penerbit16,
  penerbit17,
  penerbit18,
  penerbit19,
  penerbit20,
  penerbit21,
  penerbit22,
  penerbit23,
  penerbit24,
]

export const media = [
  media1,
  media2,
  media3,
  media4,
  media5,
  media6,
  media7,
  media8,
  media9,
  media10,
  media11,
  media12,
]